import './accordion-item.scss';
export default (() => {
  // Select all accordion titles
  const accordions = document.querySelectorAll('.accordion-title');

  // Loop through each accordion title and add a click event listener
  accordions.forEach(function (accordion) {
    accordion.addEventListener('click', function () {
      // Toggle 'opened' class on the clicked accordion's parent
      const parentAccordion = accordion.parentElement;
      parentAccordion.classList.toggle('opened');
    });
  });
});